export const networks = [
    // {
    //     name: 'canary',
    //     nodeUrl: 'https://dcomm-validators.testnet.zeeve.net',
    //     wsUrl: 'wss://dcomm-validators.testnet.zeeve.net/ext/ACT/ws',
    //     indexerUrl: 'https://dcomm-indexer-dev.testnet.zeeve.net',
    //     networkId: 6,
    //     protocol: 'https',
    //     ip: 'dcomm-validators.testnet.zeeve.net',
    //     port: 443,
    //     chainId: 'AST',
    //     dcmId: '2sPA8MJ4j3sbNjFFk9qRkfggVYN8jCuCkzWkWNqaZ21ttoYHFT',
    //     astChainId: '2HwNBijebWDHewaVuqFoHvPoUR7nWiJEMBbxMcqFfAJDoprNzF',
    //     actChainId: 'QAGnRUZjcqkmBbcRrdhrTsL3CEHTsTCt1QzJ4W51eZaXiSyAT',
    //     athChainId: '11111111111111111111111111111111LpoYY',
    //     actChainExplorerUrl: 'https://explorer.dcomm.network',
    //     dcommGoUrl: 'https://dcomm-validators.testnet.zeeve.net/ext/ATH',
    //     dcommGoEthUrl:
    //         'https://dcomm-validators.testnet.zeeve.net/ext/bc/ACT/rpc',
    //     walletUrl: 'https://wallet.dcomm.network',
    //     dcommFaucetUrl: 'https://faucet.dcomm.network/',
    //     peerInfoUrl: 'https://peerinfo.dcm-test.network/peerinfo',
    //     statusUrl: 'https://status.dcm.network',
    //     subnets: [],
    // },
    {
        name: 'goldcoast',
        nodeUrl: 'https://api-goldcoast.dcomm.network',
        wsUrl: 'wss://api-goldcoast.dcomm.network/ext/ACT/ws',
        indexerUrl: 'https://indexer-goldcoast.dcomm.network',
        networkId: 3,
        protocol: 'https',
        ip: 'api-goldcoast.dcomm.network',
        port: 443,
        chainId: 'AST',
        dcmId: 'jQUKHKoVVo2rncCSKAau8cUwgA638zowDxhk7Me8sFnP7TrbS',
        astChainId: 'CYMrs3H4kj711TwjSGcdQ4owfhcF5gwWtzekGj6wumQLFwftd',
        actChainId: '2jYyCtM8b1HDRP9rnK7JvPYNNdUM68N8jnn6RexJjVn4GyvDtj',
        athChainId: '11111111111111111111111111111111LpoYY',
        actChainExplorerUrl: 'https://explorer.dcomm.network',
        dcommGoUrl: 'https://api-goldcoast.dcomm.network/ext/ATH',
        dcommGoEthUrl: 'https://api-goldcoast.dcomm.network/ext/bc/ACT/rpc',
        walletUrl: 'http://wallet.dcomm.network',
        dcommFaucetUrl: 'https://faucet.dcomm.network',
        peerInfoUrl: 'https://peerinfo.dcm-test.network/peerinfo',
        statusUrl: 'https://status.dcm.network',
        subnets: [
            {
                tsp:
                    'https://subnet-goldcoast.dcomm.network/ext/bc/2JFccSuMrJJLMmiEEMAvBs9Nc8M8vZBSomTpGiEJ6iTdJpZJbs/rpc',
                tsp_wss:
                    'wss://subnet-goldcoast.dcomm.network/ext/bc/2JFccSuMrJJLMmiEEMAvBs9Nc8M8vZBSomTpGiEJ6iTdJpZJbs/ws',
                tsp1_wss: 'wss://dcomm-validators.testnet.zeeve.net/ext/ACT/ws',
                tsp1:
                    'https://dcomm-validators.testnet.zeeve.net/ext/bc/ACT/rpc',
            },
        ],
    },
    {
        name: 'mainnet',
        nodeUrl: 'https://api-mainnet.dcomm.network',
        wsUrl: 'wss://api-mainnet.dcomm.network/ext/ACT/ws',
        indexerUrl: 'https://indexer-mainnet.dcomm.network',
        networkId: 1,
        protocol: 'https',
        ip: 'api-mainnet.dcomm.network',
        port: 443,
        chainId: 'AST',
        dcmId: 'vUXVgKM4Lf3NnGcyBEWEyudSR3sVXW2LdyVnxMmtXV5fzYPHN',
        astChainId: 'wm7RvhEhWhwE1sLnSMoZfLYUYzRsedNAn3SHtQ1mUS4WpR847',
        actChainId: 'QHefD1LnZGBHNvWbZGVZWEPyjWt81j2chXJjo1iJYnRrXFt8J',
        athChainId: '11111111111111111111111111111111LpoYY',
        actChainExplorerUrl: 'https://explorer.dcomm.network',
        dcommGoUrl: 'https://api-mainnet.dcomm.network/ext/ATH',
        dcommGoEthUrl: 'https://api-mainnet.dcomm.network/ext/bc/ACT/rpc',
        walletUrl: 'http://wallet.dcomm.network',
        dcommFaucetUrl: 'https://faucet.dcomm.network',
        peerInfoUrl: 'https://peerinfo.dcm-test.network/peerinfo',
        statusUrl: 'https://status.dcm.network',
        subnets: [
            {
                '4mysay smart polling_wss':
                    'wss://rpc.smartpolling.zeeve.io/ext/bc/A7LQMMHpH4tRSrknRGtUdTBVhUyUFT4dRwPx6D2eSZdKTF2MK/ws',
                '4mysay smart polling':
                    'https://rpc.smartpolling.zeeve.io/ext/bc/A7LQMMHpH4tRSrknRGtUdTBVhUyUFT4dRwPx6D2eSZdKTF2MK/rpc',
                '4mysay smart polling_basic_auth':
                    'Basic bXlzYXk6azMzNjc3ZW4yN3p0',
            },
        ],
    },
]
